import TransportEmailsPage from "./TransportEmailsPage";

export default TransportEmailsPage;